<template>
  <div class="liu">
    <div class="retail-business-examine">
      <!-- title -->
      <mt-header fixed title="小微商户审核登录" class="title1 no-roll" />
      <div>
        <!-- 任务列表 -->
        <div class="examine-register">
          <div class="reg-tips">提示：请使用后台管理的账户/密码登录</div>
          <div class="reg-info">
            <div class="info-item">
              <div class="item-label">登录名称：</div>
              <input type="text" class="item-text" v-model="textBox.name" placeholder="请输入登录名" />
            </div>
            <div class="info-item">
              <div class="item-label">登录密码：</div>
              <input type="password" class="item-text" v-model="textBox.pwd" placeholder="请输入登录密码" />
            </div>
            <div class="info-item">
              <div class="item-label">验证码：</div>
              <!-- style="width:50%" -->
              <input type="text" class="item-short-text" v-model="textBox.code" placeholder="请输入验证码" />
              <img class="item-img" :src="codeImgUrl" alt="" @click="onImgClick" />
            </div>
          </div>
          <div class="reg-btn">
            <mt-button type="primary" size="large" @click="onRegisterBtnClick">
              登录
            </mt-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetToken, GetCode, Login, BindingWorkWXOpenid } from '@/api/manage';
import { SucceedHandle2, SucceedHandle3, NotSucceedHandle } from '@/api/handle';
import { CusToast } from '@/utils/CustomToast';
import { Indicator } from 'mint-ui';

export default {
  name: 'RetailBusinessExamineRegister',
  data() {
    return {
      codeImgUrl: '',
      textBox: {
        name: '',
        pwd: '',
        code: '',
      },
    };
  },
  mounted() {
    this.initData();
  },
  computed: {},
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 加载数据
      this.$nextTick(() => {
        this.getToken();
      });
    },
    // 通过接口获取数据
    getToken() {
      Indicator.open();
      GetToken()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              localStorage.setItem('token', res.msg);
              GetCode()
                .then(res => {
                  Indicator.close();
                  SucceedHandle2(
                    res.code,
                    res.msg,
                    () => {
                      this.codeImgUrl = `data:image/png;base64,${res.data.bytes}`;
                    },
                    (code, msg) => {
                      msg && CusToast(msg);
                    }
                  );
                })
                .catch(err => {
                  Indicator.close();
                  const msg = NotSucceedHandle(err.message || err.msg);
                  msg && CusToast(msg);
                });
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message || err.msg);
          msg && CusToast(msg);
        });
    },
    // 验证码点击事件
    onImgClick() {
      Indicator.open();
      GetCode()
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.codeImgUrl = `data:image/png;base64,${res.data.bytes}`;
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message || err.msg);
          msg && CusToast(msg);
        });
    },
    // 登录按钮事件
    onRegisterBtnClick() {
      Indicator.open();
      localStorage.setItem('productid', '');
      Login({ loginName: this.textBox.name, pwd: this.textBox.pwd, code: this.textBox.code })
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (this.$route.query.openid) {
                BindingWorkWXOpenid({ openid: this.$route.query.openid })
                  .then(res => {
                    SucceedHandle3(
                      res.code,
                      res.innerCode,
                      res.msg,
                      () => {
                        sessionStorage.setItem('bindStatus', 'ok');
                        this.$router.push({ path: '/retailbusinessexaminelist' });
                      },
                      (code, innerCode, msg) => {
                        Indicator.close();
                        if (innerCode === 1001) CusToast('不能使用代理商用户登录');
                        else msg && CusToast(msg);
                      }
                    );
                  })
                  .catch(err => {
                    Indicator.close();
                    const msg = NotSucceedHandle(err.message || err.msg);
                    msg && CusToast(msg);
                  });
              } else {
                sessionStorage.setItem('bindStatus', 'ok');
                this.$router.push({ path: '/retailbusinessexaminelist' });
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
              if (code === 1) {
                this.getToken();
              }
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message || err.msg);
          msg && CusToast(msg);
        });
    },
  },
};
</script>
